import AndieGoalStep from './AndieGoalStep';
import GuidedGoalStep from './GuidedGoalStep';
import type { OnboardingGoal } from './onboarding-goals';

interface OnboardingGoalStepProps {
    value: OnboardingGoal | '';
    onSelect: (goal: OnboardingGoal) => void;
    /** Whether the workspace finished onboarding with a social profile attached. */
    hasProfile: boolean;
}

/**
 * Picks which hand-off the last onboarding step is introducing.
 *
 * The rule lives here rather than being threaded through as a flag: a connected profile is the
 * whole precondition for Andie being useful, so it is also the whole precondition for showing the
 * step that promises it.
 */
const OnboardingGoalStep = ({ value, onSelect, hasProfile }: OnboardingGoalStepProps) =>
    hasProfile ? (
        <AndieGoalStep value={value} onSelect={onSelect} />
    ) : (
        <GuidedGoalStep value={value} onSelect={onSelect} />
    );

export default OnboardingGoalStep;
